<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.37802 2.7169C2.5046 2.46155 2.76498 2.3 3.04999 2.3H16.93C17.215 2.3 17.4754 2.46155 17.602 2.7169C17.7285 2.97226 17.6995 3.2773 17.5269 3.50412L12.4 10.2429V16.2478C12.4533 16.5698 12.2915 16.8923 11.9962 17.0404L8.66621 18.7104C8.43371 18.827 8.15741 18.8148 7.93608 18.6782C7.71475 18.5416 7.57999 18.3001 7.57999 18.04V10.2429L2.4531 3.50412C2.28053 3.2773 2.25144 2.97226 2.37802 2.7169ZM10.9 15.9121V9.99C10.9 9.82596 10.9538 9.66644 11.0531 9.53588L15.417 3.8H4.56298L8.92688 9.53588C9.02621 9.66644 9.07999 9.82596 9.07999 9.99V16.8248L10.9 15.9121Z"
            fill="currentColor"
        />
    </svg>
</template>
